import { render, staticRenderFns } from "./today-bonus.vue?vue&type=template&id=d87072fa&"
import script from "./today-bonus.vue?vue&type=script&lang=js&"
export * from "./today-bonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports